"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var styled_components_1 = __importStar(require("styled-components"));
var styled_system_1 = require("styled-system");
var Text_1 = require("./Text");
exports.hyperlink = styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  text-decoration: none;\n"], ["\n  color: ", ";\n  text-decoration: none;\n"])), function (_a) {
    var textColor = _a.textColor;
    return textColor || styled_system_1.themeGet('colors.primary');
});
exports.Hyperlink = styled_components_1["default"].a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  ", "\n  ", "\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  ", "\n  ", "\n  ", "\n\n  ", "\n\n  ", "\n"])), Text_1.bold, Text_1.align, Text_1.small, exports.hyperlink, styled_system_1.space);
exports.Hyperlink.displayName = 'Hyperlink';
exports.Hyperlink.defaultProps = {
    bold: true
};
exports["default"] = exports.Hyperlink;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Hyperlink.js.map